import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import PrintPO from "../../../components/utilities/print/default/po";
// middlewares
import AuthMiddleware from "../../../reducers/auth/middleware";
import PurchaseOrderMiddleware from "../../../middleware/modules/purchasing/purchase-order";

const mapStateToProps = ({ auth, purchaseOrder }) => ({
  isAuthenticated: auth.isAuthenticated,
  isRegistered: auth.isRegistered,
  isError: auth.isError,
  errorMessage: auth.errorMessage,
  isProcessing: purchaseOrder.isProcessing,
  dataPrint: purchaseOrder.printPo,
  requestPrint:purchaseOrder.requestPrint
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getPrint: (id) => PurchaseOrderMiddleware.getPrint(id),
    },
    dispatch
  );
};

class PoContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    requestPrint:PropTypes.bool
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
    requestPrint:false
  };

  UNSAFE_componentWillMount() {
    this.props.getPrint(this.props.poid);
  }

  render() {
    return <PrintPO {...this.props} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PoContainer);
